import { z } from 'zod';

import { UserSchema } from '../users/user.schema.js';
import type { AcceptCompanyInviteRequest, AcceptCompanyInviteResponse } from './accept-company-invite.dto.js';

export const AcceptCompanyInviteRequestSchema: z.ZodType<AcceptCompanyInviteRequest> = z.object({
  token: z.string().trim().min(1),
  password: z.string().min(1),
});

export const AcceptCompanyInviteResponseSchema: z.ZodType<AcceptCompanyInviteResponse> = z.object({
  accessToken: z.string().min(1),
  refreshToken: z.string().min(1),
  user: UserSchema,
  companyId: z.uuid(),
});

